import { Table } from "@vilocnv/allsetra-core";
import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { TOTAL_CO2_REPORT_DATE_RENDERING } from "app/data/constants/Reports/totalCo2ReportsConstants";
import TotalCO2ReportFinalData from "../TotalCO2ReportFinalData/TotalCO2ReportFinalData";

interface TotalCO2ReportExpendableRowCardProps {
  data: any;
  isShowKeyCol?: boolean;
}

const TotalCO2ReportExpendableRowCard: FC<
  TotalCO2ReportExpendableRowCardProps
> = ({ data, isShowKeyCol }) => {
  const { t } = useTranslation(["translation", "tableHeadingsTranslation"]);

  return (
    <Table
      columns={TOTAL_CO2_REPORT_DATE_RENDERING}
      data={data.records}
      expandableRows
      expandOnRowClicked
      expandableRowsComponent={TotalCO2ReportFinalData}
      expandableRowsComponentProps={{ isShowKeyCol: isShowKeyCol }}
      pagination={false}
      noTableHead={true}
      translator={t}
    />
  );
};

export default memo(TotalCO2ReportExpendableRowCard);
